import React, { useState, useEffect, useContext } from "react";
import { inject, observer } from "mobx-react";
import RootStore from "../../store/RootStore";
import { ILucky, ILuckyOption, IUserLucky } from "../../store/LuckyStore";
import intl from "react-intl-universal";
import { getPageSameType, fixedLength } from "../../utils/util";
import { ThemeContext } from "../../store/ThemeProvider";
import moment from "moment";
import { style } from "../../utils/image";
import chroma from "chroma-js";
import { getPendantColor } from "../../utils/color";
import { ILuckyProps, LEVEL_TITLE } from "./Lucky";
import classNames from "classnames";
import GameTimer from "./GameTimer";
import { getTimeline } from "./Lucky";
import Timer from "../Common/Timer";
import BottomModal from "../ButtonGroup/BottomModal";
import ReactSVG from "react-svg";
import "../ComponentRichText/text.scss";

const TypePan = (props: ILuckyProps) => {
  const {
    data,
    show_result,
    onLucky,
    rootStore,
    onShowPhone,
    onShowAllLuck,
    onShowMyLuck,
  } = props;
  const { luckyStore, uiStore, wxuserStore, imStore } = rootStore!;
  const [active, setActive] = useState(-1);
  const [loading, setLoading] = useState(false);
  const [showIntro, setShowIntro] = useState(false);
  const self = luckyStore.getUserLuckyed(data.id) || {
    max_join_number: 0,
    user_join_hit: 0,
    luck_list: [],
  };

  const queue = [0, 7, 6, 1, 99, 5, 2, 3, 4] as number[];
  const goods = (data.goods_detail || []).concat([
    {
      id: 0,
      name: String(0),
      desc: "谢谢参与",
      luck_id: data.id,
      thumb: "",
    },
  ] as ILuckyOption[]);

  const cubes = queue
    .filter((it: number) => it != 99)
    .map((it: number, index: number) => {
      return goods[index % goods.length];
    });

  const [game, setGame] = useState(null as any);
  const [status, setStatus] = useState("");
  const [timeline, setTimeline] = useState([] as string[]);

  const [messages, setMessages] = useState([] as string[]);
  useEffect(() => {
    if (status == "start") {
      luckyStore.getLuckResult(data.id, 1).then((res: any) => {
        if (res && res.data) {
          let { items, total } = res.data;
          setMessages(
            (items || [])
              .map((it: any) => {
                if (it && it.userdetail && it.goodsdetail) {
                  return `恭喜${it.userdetail.nickname}抽中了${it.goodsdetail.desc}`;
                }
                return null;
              })
              .filter(Boolean)
          );
        }
      });
    }
  }, [status]);

  useEffect(() => {
    const onLuckyMessage = (e: any) => {
      let { data } = e;
      let newMessages = [...messages];
      newMessages.push(`恭喜${data.nickname}抽中了${data.name}`);
      setMessages(newMessages);
    };

    imStore.addMessageListener("lucky_result_change", onLuckyMessage);

    return () => {
      imStore.removeMessageListener("lucky_result_change", onLuckyMessage);
    };
  }, [messages]);

  useEffect(() => {
    setGame(new GameTimer());
  }, []);

  const onTimeUpdate = (loop: number) => {
    setActive(loop % cubes.length);
  };

  const onTimeEnd = (target: number) => {
    setLoading(false);
    if (String(target) == "0") {
      // 弹出未中奖的
      uiStore.showBasicDialog({
        content: (
          <div className="lucky-toast" key={target}>
            <img
              src={require("../../assets/lucky_miss.png")}
              className="icon"
            />
            <p className="title">谢谢参与</p>
            <p className="desc">很遗憾，没有中奖</p>
            <div className="x-container">
              <ReactSVG
                src={require("../../svg/x.svg")}
                className="x"
                style={{ fill: "#666" }}
                onClick={() => {
                  uiStore.hideBasicDialog();
                }}
              />
            </div>
          </div>
        ),
        okText: " ",
      });
    } else {
      let good = goods.find(
        (it: ILuckyOption) => Number(it.name) == Number(target)
      );
      if (good) {
        uiStore.showBasicDialog({
          content: (
            <div className="lucky-toast" key={good.id}>
              <p className="title">中奖啦</p>
              <div className="result">
                <p>恭喜您抽中{LEVEL_TITLE[String(good.name)]}</p>
                <p>{good.desc}</p>
              </div>
              <div className="tooltip">
                <p>
                  兑奖期限：
                  {moment().add(24, "h").format("YYYY-MM-DD HH:mm:ss")}{" "}
                  (逾期则失效)
                </p>
                <p>您可在底部导航"我的"-"我的奖品"查看</p>
              </div>
              <div
                className="footer"
                onClick={() => {
                  uiStore.hideBasicDialog();
                  if (onShowPhone) {
                    onShowPhone();
                  }
                }}
              >
                <a>立即领取</a>
              </div>
              <div className="x-container">
                <ReactSVG
                  src={require("../../svg/x.svg")}
                  className="x"
                  style={{ fill: "#fff" }}
                  onClick={() => {
                    uiStore.hideBasicDialog();
                  }}
                />
              </div>
            </div>
          ),
          wrapClassName: "goodluck",
        });
      }
    }
  };

  const start = () => {
    if (loading) {
      return;
    }

    // 未登录判断
    if (wxuserStore.user.is_mock) {
      wxuserStore.auth();
      return false;
    }

    if (status == "wait") {
      uiStore.showToast({
        content: "抽奖未开始",
      });
      return;
    }

    if (status == "stop") {
      uiStore.showToast({
        content: "抽奖已结束",
      });
      return;
    }

    setLoading(true);
    const result = onLucky();
    if(result === false) {
      return;
    }
    else {
      (result as PromiseLike<any>).then((apiResult: any) => {
        if (apiResult) {
          game.start({
            target: -1,
            round: cubes.map((it: any) => it.name),
            onStep: onTimeUpdate,
            onEnd: onTimeEnd,
          });

          const minTimer = new Promise((resolve) => {
            window.setTimeout(resolve, 5000);
          });
          if (
            apiResult.data &&
            apiResult.data.id &&
            Number(apiResult.code) == 200
          ) {
            let { goods_id } = apiResult.data;
            let target = goods.find(
              (it: any) => String(it.id) == String(goods_id)
            );
            if (target) {
              Promise.all([minTimer]).then(() => {
                if (target) game.setTarget(Number(target.name));
              });
              return;
            }
          }
          Promise.all([minTimer]).then(() => {
            game.setTarget(0);
          });
        }
      });
    }
    // Promise.all([minTimer, onLucky()]).then((result: any[]) => {
    //   const [timerResult, apiResult] = result;
    //   if (apiResult) {
    //     if (Number(apiResult.code) == 200) {
    //       if (apiResult.data && apiResult.data.id) {
    //         let { goods_id } = apiResult.data;
    //         let target = goods.find(
    //           (it: any) => String(it.id) == String(goods_id)
    //         );
    //         if (target) {
    //           game.setTarget(Number(target.name));
    //           return;
    //         }
    //       }
    //     }
    //   }
    //   game.setTarget(0);
    // });
  };

  const checkDisable = ()=>{
    if(status == 'stop') {
      return true;
    }
    if(!wxuserStore.user.is_mock) {
      const lessCount = Math.max( 0,  Number(self.max_join_number) - Number(self.user_join_hit));
      if(lessCount <= 0) {
        return true;
      }
      // wxuserStore.user.is_mock ? `您还有${Number(data.max_join_number)}次抽奖机会` : `您还有${Math.max( 0,  Number(self.max_join_number) - Number(self.user_join_hit))}次抽奖机会`
    }

    return false;
  };

  const renderGoods = () => {
    let result = [[], [], []] as any;
    for (var i = 0; i < queue.length; i++) {
      result[Math.floor(i / 3)].push(queue[i]);
    }

    return result.map((it: number[], index: number) => {
      return (
        <div className="column" key={index}>
          {it.map((q: number) => {
            let cube = cubes[q];
            const isDisable = q == 99 && checkDisable();
            return q == 99 ? (
              <div className={"good clickme " + (isDisable ? `disable` : ``)} key={q} onClick={isDisable ? undefined : start}>
                <img
                  src={require("../../assets/lucky_click.png")}
                  className="background"
                />
                <div className="good-wrapper">
                  立即
                  <br />
                  抽奖
                </div>
              </div>
            ) : (
              <div
                key={q}
                className={classNames({
                  good: true,
                  [`index${q}`]: true,
                  active: q == active,
                })}
              >
                {active == q ? (
                  <img
                    src={require("../../assets/lucky_click.png")}
                    className="background"
                  />
                ) : (
                  <img
                    src={require("../../assets/lucky_good_border.png")}
                    className="background"
                  />
                )}
                <div className="good-wrapper">
                  {cube.thumb ? (
                    <img
                      src={style(cube.thumb, "wx_375_375_square")}
                      className="thumb"
                    />
                  ) : null}
                  <p className="name">{cube.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      );
    });
  };

  const onTick = () => {
    const [firstStatus, firstTimeline] = getTimeline(
      data.begin_at,
      data.end_at
    );
    setStatus(firstStatus as string);
    setTimeline(firstTimeline as string[]);
  };

  const onEndTick = ()=>{
    const [firstStatus, firstTimeline] = getTimeline(
      data.end_at,
      moment().add(1, 'month').format('YYYY-MM-DD HH:mm:ss')
    );
    setTimeline(firstTimeline as string[]);
  };

  const onStop = () => {
    console.log(`timer end`);
    // 需要去检测一下，当前抽奖活动是否已经开启
    luckyStore.checkLucky(data.id);
  };

  useEffect(() => {
    if (data && data.id) {
      onTick();
    }
  }, [data]);

  const renderHeader = () => {
    if (status == "wait") {
      return (
        <div className="header" key={status}>
          <Timer end_at={data.begin_at} onTick={onTick} onStop={onStop} />
          <div className="title">距离抽奖开始倒计时</div>
          <div className="timeline">
            {timeline.map((it: string, i: number) => {
              return (
                <div className="cube" key={i}>
                  {it}
                </div>
              );
            })}
          </div>
        </div>
      );
    }
    if (status == "start") {
      return (
        <div className="header" key={status}>
          <Timer end_at={data.end_at} onTick={onEndTick} onStop={onStop} />
          <div className="title">距离抽奖结束倒计时</div>
          <div className="timeline">
            {timeline.map((it: string, i: number) => {
              return (
                <div className="cube" key={i}>
                  {it}
                </div>
              );
            })}
          </div>
        </div>
      );
    }
    if (status == "stop") {
      return (
        <div className="header" key={status}>
          <div className="title">抽奖活动已结束</div>
        </div>
      );
    }
  };

  return (
    <div className="lucky-pan">
      <div className="wrapper">
        <div className="content">
          {renderHeader()}
          <div className="table">
            <img
              src={require("../../assets/lucky_table_background.png")}
              className="background"
            />
            <div className="content">
              <div className="count_info">
                <div className="lucky_count">
                  {status == 'stop' ? null : (
                    wxuserStore.user.is_mock ? `您还有${Number(data.max_join_number)}次抽奖机会` : `您还有${Math.max( 0,  Number(self.max_join_number) - Number(self.user_join_hit))}次抽奖机会`
                  )}
                </div>
                <div
                  className="lucky_intro"
                  onClick={() => {
                    setShowIntro(true);
                  }}
                >
                  活动介绍
                </div>
              </div>
              <div className="core-table">
                <div className="lights">
                  <img
                    src={require("../../assets/lucky_light_1.png")}
                    className="light1"
                  />
                  <img
                    src={require("../../assets/lucky_light_2.png")}
                    className="light2"
                  />
                </div>
                <div className="goods">
                  <div className="margin">{renderGoods()}</div>
                </div>
              </div>
            </div>
          </div>
          {messages.length && show_result ? (
            <div className="lucky-message">
              <div className="message-background">
                <img src={require("../../assets/lucky_message.png")} />
              </div>
              <div className="hscroll">
                <div
                  className="text"
                  style={{ animationDuration: `${messages.length * 4}s` }}
                >
                  {messages.join(" ")}
                </div>
              </div>
            </div>
          ) : null}
        </div>
        {status == "wait" ? null : (
          <div className="buttons">
            <a className="lucky-button" onClick={onShowAllLuck}>
              中奖名单
            </a>
            <a className="lucky-button" onClick={onShowMyLuck}>
              我的奖品
            </a>
          </div>
        )}
      </div>
      <BottomModal
        title={"活动介绍"}
        wrapClassName={`lucky-intro-modal`}
        show={showIntro}
        onHide={() => setShowIntro(false)}
        child={
          <div style={{ padding: "0 20px" }}>
            <div
              className="html-rawdata"
              dangerouslySetInnerHTML={{ __html: String(data.desc || "") }}
            ></div>
            <div className="lucky-intro-goods">
              <div className="lucky-intro-goods-title">奖品说明</div>
              <div className="lucky-intro-goods-list">
                {(data.goods_detail || []).map(
                  (it: ILuckyOption, index: number) => {
                    return (
                      <div className="lucky-intro-goods-item" key={it.id}>
                        <img
                          src={style(it.thumb, "wx_375_375_square")}
                          className="thumb"
                        />
                        <div className="intro-info">
                          <div className="level">
                            {LEVEL_TITLE[String(it.name)]}
                          </div>
                          <div className="desc">
                            {it.desc} <span>数量：{it.count_num || 0}</span>
                          </div>
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default inject("rootStore")(observer(TypePan));
